import { FormattedMessage } from "react-intl";
import ExclamationCircleIcon from "@heroicons/react/24/outline/ExclamationCircleIcon";

import { CaptchaError } from "@/lib/types/runtimeTypes";

export type CaptchaErrorType = CaptchaError | null;

export interface CaptchaErrorProps {
  errorType: CaptchaErrorType;
  onRetry: () => void;
}

export const CaptchaErrorComponent = ({ errorType, onRetry }: CaptchaErrorProps) => {
  if (!errorType) {
    return null;
  }

  return (
    <div className="sid-captcha-notification" role="alert" data-testid={errorType}>
      <div className="sid-captcha-notification__icon-wrapper">
        <ExclamationCircleIcon className="sid-captcha-notification__icon" />
      </div>
      <div>
        {errorType !== CaptchaError.SERVER && (
          <span className="sid-captcha-notification__title">
            <FormattedMessage
              id={`step.personalInfo.captcha.error.${errorType}.title`}
              defaultMessage="Verification Unsuccessful, Please try again."
            />
          </span>
        )}{" "}
        <FormattedMessage
          id={`step.personalInfo.captcha.error.${errorType}.content`}
          defaultMessage="If the issue persists, disable any VPN or ad-blocking extensions and retry."
        />
      </div>
      {errorType === CaptchaError.CLIENT && (
        <button type="button" className="sid-captcha-notification__retry-button" onClick={onRetry}>
          <FormattedMessage id="step.personalInfo.captcha.retryButton" />
        </button>
      )}
    </div>
  );
};
